import { fetchInformationCenter } from '../../api/information-center'

export default {
  state: {
    telegramLink: '',
    notifications: [],
    announcements: [],
  },
  getters: {},
  mutations: {
    setTelegramLink(state, data) {
      state.telegramLink = data
    },
    setNotifications(state, data) {
      state.notifications = data
    },
    setAnnouncements(state, data) {
      state.announcements = data
    }
  },
  actions: {
    getInformationCenter(context) {
      fetchInformationCenter().then(res => {
        // context.commit('setTelegramLink', res.support[0].linkurl)
        context.commit('setNotifications', res.notification)
        context.commit('setAnnouncements', res.announcement)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/informationCenter.js